import { UserExtraLite } from "../auth";

export class Status {
    user : UserExtraLite;
    action: string; // 'started' | 'completed' | 'passed' | 'approved' | 'cancelled' | 'invited' | 'registered' (trainer has assigned) | 'joined' (learner has done the initial signup) etc
    metric: number; // 72 // % completion etc, if the action is in_progress
    model: { statusable_type; string, statusable_id: number}; 
    created_at: string;
    updated_at: string;
}